import Container from "./Container";
import UserInfo from "components/UserInfo";

function index(props) {
  return (
    <UserInfo>
      <Container {...props} />
    </UserInfo>
  );
}

export default index;
